const validationAttributes = {
  amount: 'Amount',
  chosenDiscountValue: 'Discount',
  email: 'Email Address',
  firstName: 'First Name',
  identifier: 'Unique Code',
  lastName: 'Last Name',
  name: 'Name',
  newStock: 'Stock',
  note: 'Note',
  paidAmount: 'Amount',
  pin: 'PIN Code',
  priceInclVat: 'Amount',
  quantity: 'Quantity',
  'countedTotals.amount': 'Amount'
}

export default validationAttributes



// WEBPACK FOOTER //
// ./src/validation/attributes.js